var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionButtonDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.943,
    height: 14.95,
    viewBox: "0 0 11.943 14.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iocn_Download",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9365",
    "data-name": "Group 9365",
    transform: "translate(10.602 11.176) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13597",
    "data-name": "Path 13597",
    d: "M0,10.943V0",
    transform: "translate(5.13 0.233)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13598",
    "data-name": "Path 13598",
    d: "M0,3.484,5.175,0l5.084,3.484",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13599",
    "data-name": "Path 13599",
    d: "M0,10.943V0",
    transform: "translate(10.943 13.95) rotate(90)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButtonDownload);
export default __webpack_public_path__ + "static/media/action_button_download.4136ffd4c1497b5c6c3daaebf07a04c7.svg";
export { ForwardRef as ReactComponent };